var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingP6 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 350.003,
  height: 333.331,
  viewBox: "0 0 350.003 333.331"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "parking_P6_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 249.998h262.502V0H0z"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0072ce",
  d: "m0 0 .013 333.33h349.99V0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#parking_P6_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 333.33)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M94.02 157.17h-9.647v41.958h9.646c14.184 0 26.2-5.513 26.2-21.47 0-15.954-12.413-20.488-26.2-20.488m-2.37 63.63H56.787V83.303h27.587v52.194H95.99c29.55 0 52.99 11.626 52.99 43.734 0 32.904-27.378 41.57-57.328 41.57M160.33 52.953c0-2.6 0-13.917 9.232-13.917 8.457 0 9.238 10.925 9.238 15.61 0 4.033-.916 14.31-9.238 14.31-9.232 0-9.232-11.188-9.232-16.003m33.296 46.184c-3.77 1.562-9.625 4.033-15.086 4.033-15.61 0-18.612-13.79-19.253-26.67h.26c5.984 7.284 13.008 7.803 15.48 7.803 12.88 0 24.326-10.797 24.326-30.7 0-5.594-2.997-29.01-28.62-29.01-25.63 0-30.962 23.936-30.962 43.578 0 25.63 8.588 50.348 35.65 50.348 7.28 0 12.488-1.433 19.38-3.643z"
}))));
export default SvgParkingP6;